import React from 'react';

export default function ArchiveConfirmModal({
    isOpen,
    studentName,
    onCancel,
    onConfirm
}) {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h3>Подтверждение архивации</h3>
                <p>Вы действительно хотите архивировать ученицу <strong>{studentName}</strong>?</p>
                <div className="modal-actions">
                    <button className="btn-secondary" onClick={onCancel}>
                        Отмена
                    </button>
                    <button className="btn-archive" onClick={onConfirm}>
                        Архивировать
                    </button>
                </div>
            </div>
        </div>
    );
}
